<style lang="stylus">
    .color__active
        color #037FFF
        background-color #D9ECFF

    .color__active2
        color #017FFF
        font-weight bold
    .color__race
        color #ff7a3f
        cursor pointer
        user-select none

    .work-filter
        user-select none
        font-size 14px
        color #606060
        margin-bottom 24px
        position relative
        .work-spin
            position absolute
            left 50%
            transform translateX(-50%)
            bottom -96px
            .spin-dot
                width: 40px;
                height: 40px;
        .mindmaster-tip
            outline none
            position fixed
            z-index 10
            top 26%
            left 50%
            transform translate(-50%, -50%)
            overflow hidden
            width 594px
            height 317px
            box-shadow 0 4px 18px #999
            background #fff
            border-radius 7px
            .mindmaster-tip-title
                height 41px
                background #00be84
                background-repeat no-repeat
                background-position 31px center
                display flex
                align-items center
                justify-content flex-end
                img
                    margin-right 21px
                    cursor pointer
            .mindmaster-name
                margin-top 43px
                font-size 21px
                color #424242
                text-align center
                font-family NotoSans-SemiBold
                font-weight bold
            .mindmaster-sub
                font-size 21px
                color #666
                text-align center
                margin-top 18px
            .mindmaster-btn
                width 157px
                height 42px
                border-radius 22px
                text-align center
                font-size 18px
                cursor pointer
                color #ffffff
                line-height 42px
                overflow hidden
                margin 60px auto 0
                background no-repeat center


        .ed-select-dropdown
            max-height none
            width auto
    .work-filter--container
        position relative
        padding 18px 24px 6px
        margin-bottom 16px
        background-color white
        border-radius 4px


    .work-filter--class
        // display flex
        // justify-content flex-start
        // align-items center
        // flex-wrap no-wrap
        margin-bottom 6px
        position relative


    .work-filter--line
        background-color #fff
        border-radius 4px
        position relative


    .work-filter--conditions
        padding 12px 24px
        display flex
        justify-content space-between
        align-items center

    .work-img--item
        img
            pointer-events none
            display block
            width 32px
            height 32px
            margin 0 auto
        span
            pointer-events none
            display block
            font-size 13px
            text-align center

    .work-filter--class-left
        width 66px;
        position absolute;

    .work-filter--class-right
        margin-left 66px
        display flex
        justify-content flex-start
        align-items center
        flex-wrap wrap

    .work-filter--item
        border none !important
        font-size 14px !important
        margin-right 20px
        margin-bottom 6px
        cursor pointer
        border-radius 3px
        transition all $transition-time $ease-in-out
        white-space nowrap
        padding 6px 12px
        line-height 16px
        user-select none
        position relative
        .mm-extraicon
            position absolute
            top 0
            right 6px
            width 24px
            height 24px

        &:hover
            color #017fff

    .work-filter-foldrev
        transform rotateX(180deg)

    .work-class-folded
        height 34px
        overflow hidden

    .work-class2-folded
        height 34px
        overflow hidden

    .work-filter--fold
        position absolute
        right 15px
        top 3px

        svg
            cursor pointer
            width 20px
            height 20px

    .work-filter--expand
        display flex
        justify-content center
        align-items center
        position absolute
        right 0
        bottom 0
        width 24px
        height 24px
        user-select none
        cursor pointer
        &:hover
            background-color #e5e5e5
        svg
            width 18px
            height 18px

    .work-filter--class-hint
        margin-right 25px
        line-height 16px
        padding 6px 0
        white-space nowrap

    .work-filter--pointer
        cursor pointer

    .work-filter--price
        .ivu-radio-inner
            border-radius 3px
            font-size 27px
            font-family 'Ionicons'

            &:after
                content '\F171'
                background none
                position relative
                top -7px
                left -7px
                color white

        .ivu-radio-checked
            .ivu-radio-inner
                background #017fff

    .work-filter--space
        flex 1 1 auto

    .expand-menu--container
        position fixed
        width 100vw
        height 100vh
        left 0
        top 0
        z-index 100
        .expand-menu--mask
            modal-mask()
            z-index unset
        .expand-menu--box
            display flex
            position absolute
            top 50%
            left 50%
            width 840px
            height 560px
            padding 40px 10px 10px 0
            transform translate(-50%, -50%)
            background #fff
            border-radius 10px
            box-shadow 0px 2px 20px rgba(0, 0, 0, 0.2)
            .expand-search--box
                position absolute
                display flex
                justify-content center
                align-items center
                top 0
                left 148px
                height 45px
                width calc(100% - 158px)
                background #fcfcfc
            .expand-menu-leftbar
                position relative
                width 138px
                margin-right 10px
                --top 0
                &::after
                    position: absolute
                    content ''
                    height 52px
                    top calc(var(--top, -299) * 1px)
                    color var(--themeColor)

                &::after
                    border-right solid
                    right -2px
                    transition top .2s linear

                li
                    width 100%
                    height 52px
                    padding 10px
                    color rgba(0, 0, 0, 0.6)
                    font-size 14px
                    text-align center
                    line-height 32px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    transition background .2s linear
                    &:hover,&.active
                        background #fafafa
                        color var(--themeColor)
            .expand-menu-content
                width calc(100% - 148px)
                height 100%
                padding 0 10px
                list-style none
                overflow-y auto
                background #fcfcfc
                color rgba(0, 0, 0, 0.6)
                &::-webkit-scrollbar
                    height 8px
                    width 8px
                    background-color #fafafa
                    pointer-events none

                &::-webkit-scrollbar-corner
                    background rgba(0, 0, 0, 0.2)

                &::-webkit-scrollbar-thumb
                    border-radius 6px
                    background rgba(0, 0, 0, 0.2)
                    pointer-events none

                &::-webkit-scrollbar-track
                    border-radius 1px
                    pointer-events none

                >li
                    display flex
                    padding 30px 10px 10px 10px
                    &:not(:last-child)
                        border-bottom 1px solid rgba(0,0,0,.08)
                    .expand-content-title
                        flex-shrink 0
                        width 125px
                        height 100%
                        font-size 14px
                        font-weight 500
                        text-align left
                        line-height 20px
                        text-indent 20px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    .expand-content-label
                        width 100%
                        list-style none
                        li
                            float left
                            margin-right 30px
                            margin-bottom 15px
                            font-size 12px
                            cursor pointer
                            &:hover
                                color var(--themeColor)
                            &.expand-search-hightlight
                                color var(--themeColor)
    .work-filter.dark-theme__workclass
        color #fff
        .work-filter--container
            background #333
        .work-filter--line
            background #333
        .color__active
            background rgba(1, 127, 255, 0.2)
        .work-filter--price
            .ivu-radio-inner
                background #222
            .ivu-radio-wrapper-checked .ivu-radio-inner
                background #017fff
</style>
<template>
    <div class="work-filter" :class="{ 'dark-theme__workclass': isPCDarkMode == 2 }">
        <div v-show="editorTags && editorTags.length && albumPageStatus == 'default'" v-cloak class="work-filter--container">
            <div class="work-filter--class" :class="{ 'work-class-folded': lv1line === 1 }">
                <div class="work-filter--class-left">
                    <div class="work-filter--class-hint">{{ $t("class") }}：</div>
                </div>
                <div class="work-filter--class-right" ref="lv1Con">
                    <!-- <div
                        class="work-filter--item"
                        :class="{'color__active':!activeLv1}"
                        @click="setActiveLv1(null)"
                    >
                        全部
                    </div> -->
                    <div
                        v-for="lv1 in editorTags"
                        :key="lv1.lv1id"
                        v-text="lv1.lv1name"
                        class="work-filter--item"
                        :class="{ color__active: activeLv1 && activeLv1.lv1id === lv1.lv1id }"
                        @click="setActiveLv1(lv1)"
                    ></div>
                </div>
                <div v-if="lv1line" class="work-filter--fold">
                    <iconSymbol name="ed-fold-filter" :class="{ 'work-filter-foldrev': lv1line === 2 }" @click.native="toggleFold(1)" />
                </div>
                <!-- <div class="work-filter--space" /> -->
            </div>
            <div v-if="lv2s" class="work-filter--class" :style="lv2Style" :class="{ 'work-class2-folded': lv2line === 1 }">
                <div class="work-filter--class-left">
                    <div class="work-filter--class-hint" v-text="lv2text"></div>
                </div>
                <div class="work-filter--class-right" ref="lv2Con">
                    <div
                        v-if="lv2s"
                        v-for="lv2 in lv2s"
                        :key="lv2.lv2id"
                        class="work-filter--item work-img--item"
                        :class="lv2Class(lv2)"
                        @click="setActiveLv2(lv2)"
                    >
                        <!-- <img v-if="lv2.lv2id == 1019" class='mm-extraicon' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAbBJREFUSIntlTssQ1EYx3/3ekU00cHCgkE9Ih7xCDaJBItJRMJiUWJiNSgRo1kHLBKLGFgQicSAoAkllA5qqcWANqKvXMOniN62N9ImBv/lnnPu+f6/+93vOzmK5kAjjVLTaf4P+OOAQBA83uQGHq/sjadMvcXXNxiehWc/1JTBzChk/PiUcASmFsDphnwT2CchL9dgBmc3Yg5iYLOD9u20aJqsOd0yf/bD+a1+BrqAcCQWOLsoxpoGyxuxhj9jEgKiys6CrjYZH1/C3BKcXEEgBAVm6O+UPYmUtIvG+qC9UcZHF7C2K/98fAAGupNFG2zTiUFoqJTx9R3c3kvxjcgQwOkGSzFUlsrccQ3zK8YAum36XatbsHMEzdXQ2wGb+1L0vVPIyU4OSJhBKAyr2/D4BDlZ0FQFNivUl8v7rQMIhn4ByMyQZ7Qtay0w1AOKIgfOZo2tQTTGEKDWIp0CYmSzivlnkArTI1+QfBPUlesDlHg3WiAID49QUqQfGJXHC4UF8esRF5AqqcBLGv39KrCbRsCOojmoAA4Bc4rNn4BWFXABLcA64EuBse/DqwVwvQPreIEUWxv5qgAAAABJRU5ErkJggg=="> -->
                        <!-- <img v-if="!lv2.lv3" style="margin-bottom: 5px" :src='ImgUrl(lv2,2)' /> -->
                        <span>{{ lv2.lv2name }}</span>
                    </div>
                </div>
                <div v-if="lv2line" class="work-filter--fold">
                    <iconSymbol name="ed-fold-filter" :class="{ 'work-filter-foldrev': lv2line === 2 }" @click.native="toggleFold(2)" />
                </div>
                <!-- <div class="work-filter--space" /> -->
            </div>
            <div v-if="lv3s" class="work-filter--class" :class="{ 'work-class2-folded': lv3line === 1 }">
                <div class="work-filter--class-left">
                    <div class="work-filter--class-hint" style="margin-bottom: auto">{{ $t("shape") }}：</div>
                </div>
                <div class="work-filter--class-right" ref="lv3Con">
                    <div
                        v-if="lv3s"
                        v-for="lv3 in lv3s"
                        :key="lv3.lv3id"
                        class="work-filter--item work-img--item"
                        :class="{ color__active: activeLv3 && lv3.lv3id === activeLv3.lv3id }"
                        @click="setActiveLv3(lv3)"
                    >
                        <!-- <img style="margin-bottom: 5px" :src='ImgUrl(lv3,3)' /> -->
                        <span>{{ lv3.lv3name }}</span>
                    </div>
                    <!-- <div class="work-filter--space" /> -->
                </div>
                <div v-if="lv3line" class="work-filter--fold">
                    <iconSymbol name="ed-fold-filter" :class="{ 'work-filter-foldrev': lv3line === 2 }" @click.native="toggleFold(3)" />
                </div>
            </div>

            <div class="work-filter--expand" id="workExpandBox" @click="showExpandBox()">
                <iconSymbol name="expand-menu" />
            </div>
        </div>

        <div v-show="editorTags && editorTags.length" v-cloak class="work-filter--line work-filter--conditions">
            <div class="work-filter--options">
                <!-- <span
                    v-show="$store.state.tplCenter.openSuggest && params.islogin"
                    class="work-filter--item"
                    :class="{'color__active':activeLabel=='suggest'}"
                    @click="setActiveLabel('suggest')"
                >每日推荐</span> -->
                <!-- <span
                    v-show="params.islogin"
                    class="work-filter--item"
                    :class="{'color__active':activeLabel=='follow'}"
                    @click="setActiveLabel('follow')"
                >我关注的</span>-->
                <span
                    v-for="item in filterList"
                    v-show="!(item.key == 'suggest' && !$store.state.tplCenter.openSuggest)"
                    :key="item.id"
                    class="work-filter--item"
                    :class="{ color__active2: activeLabel == item.key }"
                    @click="setActiveLabel(item.key)"
                >
                    {{ item.name }}
                </span>
                <span
                    class="work-filter--item"
                    :class="{ color__active2: activeLabel == 'HOT' }"
                    style="padding-left: 25px"
                    @click="setActiveLabel('HOT')"
                    v-if="albumPageStatus == 'default'"
                >
                    <img style="position: absolute; top: 0; left: 0" src="@/home/assets/img/fire.png" />
                    {{ "一周热榜" }}
                </span>

                <span
                    v-if="albumPageStatus == 'default' && !isPlugin"
                    class="work-filter--item"
                    :class="{ color__active2: activeLabel == 'FOLLOW' }"
                    @click="setActiveLabel('FOLLOW')"
                >
                    {{ "我的关注" }}
                </span>
            </div>
            <div class="work-filter--price" v-show="!['HOT', 'FOLLOW'].includes(activeLabel) && !isPlugin">
                <RadioGroup v-model="price">
                    <Radio label="1">
                        {{ $t("all") }}
                    </Radio>
                    <Radio label="2">
                        {{ $t("free") }}
                    </Radio>
                    <Radio label="3">
                        {{ $t("pay") }}
                    </Radio>
                    <Radio label="4">
                        {{ $t("vipFree") }}
                    </Radio>
                </RadioGroup>
            </div>
        </div>
        <div v-show="showSpin" class="work-spin">
            <div class="spin-dot" :style="{ background: `url(${require('@/home/assets/img/loading.svg')})` }"></div>
        </div>
        <div class="mindmaster-tip" ref="mindTip" tabindex="-1" @blur="closeMind" v-if="showMindmaster">
            <div
                class="mindmaster-tip-title"
                :style="{
                    backgroundImage: `url(${require('@/home/assets/img/newPage/logo.svg')})`,
                }"
            >
                <img :src="require('@/home/assets/img/newPage/close.svg')" alt="" @click="showMindmaster = false" />
            </div>
            <div class="mindmaster-name">MindMaster</div>
            <div class="mindmaster-sub">{{ $t("mindmaster") }}</div>
            <div class="mindmaster-btn" :style="{ backgroundImage: `url(${require('@/home/assets/img/newPage/btn.svg')})` }" @click="seeNow">
                {{ $t("mindmasterBtn") }}
            </div>
        </div>

        <div class="expand-menu--container" v-show="showExpand">
            <div class="expand-menu--mask" :class="{ noMask: isPC }" @click="closeExpand()"></div>
            <div class="expand-menu--box">
                <div class="expand-search--box">
                    <Input style="width: 400px" size="small" search v-model="searchStr" :placeholder="$t('search')" @on-search="searchExpand" />
                </div>
                <ul ref="expandLeftbar" class="expand-menu-leftbar" style="--top: 0">
                    <li
                        :class="{ active: item.id == activeMenuID }"
                        v-for="item in expandLeftList"
                        :key="item.id"
                        @mouseenter="selectExpandLeftMenu(item.id)"
                    >
                        {{ item.label }}
                    </li>
                </ul>
                <ul class="expand-menu-content">
                    <li v-for="item in expandContentList" :key="item.id">
                        <div class="expand-content-title">
                            <p>{{ item.label }}</p>
                        </div>
                        <ul class="expand-content-label">
                            <li
                                :class="{
                                    'expand-search-hightlight': activeSearchID == asd.lv2id || activeSearchID == asd.lv3id,
                                }"
                                v-for="asd in item.child"
                                :key="asd.id"
                                @click="toExpandTag(item, asd)"
                            >
                                {{ asd.label }}
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<i18n>
{
  "zh": {
    "mindmaster": "一款更加专业的跨端思维导图工具",
    "mindmasterBtn": "立即访问",
    "all": "全部",
    "free": "免费",
    "pay": "付费",
    "vipFree": "会员免费",
    "shape": "图形",
    "class": "分类",
    "search": "搜索标签"
  },
  "en": {
    "mindmaster": "A Professional Cross-platform Mind Mapping Tool",
    "mindmasterBtn": "See Now"
  },
  "es": {
    "mindmaster": "Una herramienta profesional de mapas mentales multiplataforma",
    "mindmasterBtn": "Ver ahora",
    "all": "Todos",
    "free": "Gratis",
    "pay": "Pagar",
    "vipFree": "Gratis para miembros",
    "shape": "Forma",
    "class": "Clasificación",
    "search": "Etiquetas de búsqueda"
  },
  "jp": {
    "mindmaster": "マルチプラットフォームで利用できるプロ並みのマインドマッピング ツール",
    "mindmasterBtn": "今すぐ見る",
    "all": "すべて",
    "free": "無料",
    "pay": "有料",
    "vipFree": "vipなら無料",
    "shape": "図形",
    "class": "カテゴリー",
    "search": "タグ"
  },
  "fr": {
    "mindmaster": "Un outil de mind mapping cross-terminal plus professionnel",
    "mindmasterBtn": "Visitez maintenant",
    "all": "tout",
    "free": "gratuit",
    "pay": "payer",
    "vipFree": "vip gratuit",
    "shape": "Graphique",
    "class": "classification",
    "search": "chercher"
  },
  "pt": {
    "mindmaster": "Uma ferramenta profissional de mapeamento mental entre plataformas",
    "mindmasterBtn": "Veja Agora",
    "all": "todo",
    "free": "gratuito",
    "pay": "pagar",
    "vipFree": "vip gratuito",
    "shape": "forma",
    "class": "classificar",
    "search": "buscar"
  },
  "de": {
    "mindmaster": "Ein professionelleres Cross-Terminal-Mind-Mapping-Tool",
    "mindmasterBtn": "Jetzt besuchen",
    "all": "Alles",
    "free": "Kostenlos",
    "pay": "Bezahlen",
    "vipFree": "VIP kostenlos",
    "shape": "Formen",
    "class": "Kategorie",
    "search": "Suchen"
  },
  "it": {
    "mindmaster": "Uno strumento di mappatura mentale cross-terminale più professionale",
    "mindmasterBtn": "Vedi ora"
  },
  "tw": {
    "mindmaster": "一款更加專業的跨端心智圖工具",
    "mindmasterBtn": "立即訪問",
    "all": "全部",
    "free": "免費",
    "pay": "付費",
    "vipFree": "會員免費",
    "shape": "圖形",
    "class": "分類",
    "search": "搜索標籤"
  },
  "kr": {
    "mindmaster": "데이터를 시각화해주는 마인드맵 프로그램",
    "mindmasterBtn": "바로 확인하기",
    "all": "전부",
    "free": "무료",
    "pay": "유료",
    "vipFree": "회원 무료",
    "shape": "셰이프",
    "class": "분류",
    "search": "검색 태그"
  },
  "id": {
    "mindmaster": "Alat Pemetaan Pikiran Lintas Platform Profesional",
    "mindmasterBtn": "Lihat Sekarang"
  }
}
</i18n>
<script>
    let classTrans = {
        全部: "All",
        UML图: "UML Modeling",
        报告表: "Report Form",
        基本电路图: "Basic Electrical",
        平面布置图: "Building Plan",
        数据流模型: "Data Flow Model",
        时间线: "Timelines",
        基本网络图: "Basic Network Diagram",
        基本流程图: "Basic Flowchart",
        思维导图: "Mind Map",
        组织结构图: "Organizational Chart",
        流程图: "Flowchart",
        数据流程图: "Data Flow Diagram",
        泳道图: "Swim Lane Diagram",
        BPMN: "BPMN",
        事件流程图: "Event Flow Diagram",
        IDEF图: "IDEF Diagram",
        SDL图: "SDL Diagram",
        工作流程图: "Workflow Diagram",
        审计流程图: "Audit Diagram",
        组织架构图: "Org Structure",
        家庭树: "Family tree",
        家谱图: "Genogram",
        MindMaster: "MindMaster",
        "软件/计算机": "Software/Computer",
        软件开发: "Software Development",
        "Booch OOD": "Booch OOD",
        "COM&OLE": "COM and OLE",
        企业应用: "Enterprise Application",
        用例图: "Jacobson Use Case",
        Jackson图: "Jackson图",
        程序流程图: "Program Flowchart",
        程序架构图: "Program Structure",
        "N-S图": "Nassi-Shneiderman",
        Room图: "Room",
        "Shaler-Mellor OOA": "Shlaer-Mellor OOA",
        SSADM: "SSADM",
        "Yourdon&Coad": "Yourdon and Coad",
        数据库: "Database Modeling",
        "Chen ERD图": "Chen ERD",
        数据库模型图: "Database Model Diagram",
        "Express-G": "Express-G",
        "Martin ERD": "Martin ERD",
        ORM图: "ORM Diagram",
        网络图: "Network",
        AWS: "AWS",
        Azure: "Azure",
        GCP: "GCP",
        思科网络拓扑图: "Cisco Network Topology",
        思科产品符号: "Cisco Product Icons",
        思科安全符号: "Cisco Safe Icons",
        详细网络图: "Detail Network Diagram",
        逻辑网络图: "Logical Network Diagram",
        机架图: "Rack Diagram",
        LDAP: "LDAP",
        活动目录: "Active Directory",
        网络位置关系图: "Network Location Diagram",
        视频和音频端口: "Video and Audio Ports",
        线框图: "Wireframe",
        网站线框图: "Website Wireframe",
        "Windows UI": "Windows UI",
        "iPhone UI": "iPhone UI",
        "Android UI": "Android UI",
        "iPad UI": "iPad UI",
        概念型网站图: "Conceptual Web Site",
        网站地图: "Website Map",
        专业领域绘图: "Building Plan",
        家居规划: "Home Plan",
        办公室布局: "Office Layout",
        电气和电信规划: "Electrical and Telecom Plan",
        座位图: "Seating Plan",
        安全和门禁平面图: "Security and Access Plan",
        花园设计: "Garden Design",
        消防疏散图: "Fire and Emergency Plan",
        天花板反向图: "Reflected Ceiling Plan",
        暖通空调: "Plumbing and Piping Plan",
        立面图: "Elevations",
        衣柜设计: "Wardrobe",
        电路工程: "Electrical Engineering",
        电路与逻辑: "Circuits and Logic",
        工业控制系统: "Industrial Control Systems",
        系统: "Systems",
        工艺流程图: "Process Flow Diagram",
        管道和仪表图: "Piping and Instrumentation Diagram",
        工业工程: "Industrial Engineering",
        "过程P&ID": "Process P&amp;ID",
        "公用发电P&ID": "Utility-Generation P&amp;ID",
        "环境P&ID": "Environmental P&amp;ID",
        "辅机系统P&ID": "Auxillary System P&amp;ID",
        "配送P&ID": "Distribution P&amp;ID",
        地图: "Map",
        "3D方向图": "Directional Map 3D",
        方向图: "Directional Map",
        地铁线路图: "Subway Map",
        地理地图: "Geo Map",
        教育科学: "Science and Education",
        数学: "Mathematics",
        力学: "Mechanics",
        光学: "Optics",
        化学方程式: "Chemistry Equation",
        实验室设备: "Laboratory Equipment",
        分子模型: "Molecular Model",
        人体器官: "Human Organs",
        生物: "Biology",
        天文学: "Astronomy",
        图形组织: "Graphic Organizer",
        图形表格: "Graphic Table",
        图表: "Graphs and Charts",
        柱状图: "Column",
        条形图: "Bar",
        饼图: "Pie",
        环形图: "Doughnut",
        线形图: "Line",
        面积图: "Area",
        散点图: "Scatter",
        气泡图: "Bubble Chart",
        仪表图: "Gauges",
        蜘蛛雷达图: "Spider Chart",
        比较图: "Comparisons",
        表格: "Form",
        发票: "Invoice",
        销售表格: "Sales Form",
        费用报销表: "Expense Report",
        库存列表: "Inventory List",
        报价单: "Quote Form",
        市场分析: "Marketing Diagrams",
        漏斗图: "Funnel Charts",
        金字塔图: "Pyramid Diagrams",
        销售图: "Sales",
        市场分析图: "Marketing Diagrams",
        "商务/PPT": "Business/PPT",
        基本绘图: "Basic Diagram",
        箭头: "Arrows",
        "2D框图": "Block Diagram",
        圆辐示意图: "Circle-Spoke Diagram",
        圆形图: "Circular Diagram",
        列表: "Lists",
        韦恩图: "Venn Diagram",
        商务: "Business",
        演示: "Presentation",
        日程: "Agenda",
        商业流程: "Business Process",
        企业架构: "Enterprise Architecture",
        人力资源: "Human Resource",
        团队协作: "Team Cooperation",
        关系矩阵: "Relationship Matrix",
        目标图: "Target Diagrams",
        愿景和使命: "Vision and Mission",
        线路图: "Roadmap",
        消费者旅程图: "Customer Journey Mapping",
        拼图: "Picture Collage",
        分析画布: "Analysis Canvas",
        商业分析画布: "Business Analysis",
        产品策划画布: "Product Planning",
        项目进度画布: "Project Progress Analysis",
        策略分析画布: "Strategy Analysis",
        团队管理画布: "Team Management",
        终身学习画布: "Lifelong Learning",
        "管理/咨询": "Management/Consulting",
        项目管理: "Project Management",
        甘特图: "Gantt Charts",
        看板图: "Kanban Diagrams",
        清单表: "Checklists",
        项目日历: "Project Calendar",
        PERT图: "PERT Chart",
        决策树: "Decision Tree",
        WBS图: "WBS Design",
        状态表: "Status Table",
        管理: "Management",
        决策: "Decision Making",
        故障树分析: "Fault Tree Analysis",
        戴明圆环: "Plan-Do-Check-Act",
        鱼骨图: "Cause and Effect Diagram",
        质量屋: "House of Quality",
        关系图: "Relation Diagram",
        品管七大手法: "Seven Basic Tools of Quality",
        全面质量管理: "TQM Diagram",
        价值流图: "Value Stream Mapping",
        战略规划: "Strategy and Planning",
        亲和图: "Affinity Diagram",
        SWOT分析图: "SWOT Analysis",
        竞争分析: "Competitive Analysis",
        五力分析: "Five Forces Analysis",
        力场分析: "Force Field Analysis",
        目标矩阵: "Goals Grid",
        绩效棱柱模型: "Performance Prism",
        PEST分析: "PEST Analysis",
        价值链: "Value Chain Analysis",
        平面设计图: "Graphic Design",
        年报: "Annual Reports",
        横幅: "Banner",
        折页: "Brochure",
        证书: "Certificate",
        封面: "Cover",
        宣传单: "Flyer",
        CD封面: "Label",
        杂志: "Magazines",
        新闻稿: "Newsletter",
        海报: "Poster",
        信息图: "Infographic",
        建筑: "Architecture",
        商业: "Business",
        教育: "Education",
        环境: "Environment",
        食品: "Food",
        医疗: "Medical",
        音乐: "Music",
        科技: "Technology",
        新闻: "News",
        旅游: "Tourism",
        交通: "Transportation",
        卡片: "Card",
        名片: "Business Card",
        感谢卡: "Thank You Card",
        邀请卡: "Invitation Card",
        明信片: "Postcard Card",
        生日贺卡: "Birthday Card",
        圣诞贺卡: "Christmas Card",
        万圣节贺卡: "Halloween Card",
        狂欢节贺卡: "Carnival Card",
        儿童节贺卡: "Childrens Day Card",
        复活节贺卡: "Easter Card",
        新年贺卡: "New Year Card",
        情人节贺卡: "Valentines Day Card",
    };
    export default {
        name: "WorkClass",
        components: {},
        props: {
            showSpin: Boolean,
        },
        data() {
            return {
                showMindmaster: false,
                filterList: [
                    { key: "PV", name: "社区精选" },
                    { key: "TIME", name: "最新发布" },
                    { key: "USED", name: "最多使用" },
                ],
                lv1line: 0, // 0 未显示，1，折叠，2，展开
                lv2line: 0,
                lv3line: 0,
                // activeLabel: "", //当前选中的栏目 suggest 我的推荐, follow 我关注的， hot latest popular
                price: "1", // 1全部 2免费 3付费 4会员免费

                showExpand: false, // 显示扩展窗口
                activeMenuID: 0, // 当前激活的菜单id
                searchStr: "", // 搜索
                activeSearchID: -1, // 搜索高亮id
                mountedDone: false,
                getTagCallback: [],
            };
        },
        computed: {
            activeLv1: {
                get: function () {
                    return this.$store.state.activeLv1;
                },
                set: function (v) {
                    this.$store.commit("setState", { type: "activeLv1", data: v });
                },
            },
            activeLv2: {
                get: function () {
                    return this.$store.state.activeLv2;
                },
                set: function (v) {
                    this.$store.commit("setState", { type: "activeLv2", data: v });
                },
            },
            activeLv3: {
                get: function () {
                    return this.$store.state.activeLv3;
                },
                set: function (v) {
                    this.$store.commit("setState", { type: "activeLv3", data: v });
                },
            },
            editorTags() {
                return this.$store.state.tplCenter.editorTags;
            },
            lv2s() {
                return this.activeLv1 && this.activeLv1.lv2;
            },
            lv2Style() {
                console.log(this.lv2s[0]);
                if (this.lv2line === 1 && this.lv2s[0].lv3) {
                    return {
                        height: "34px",
                    };
                } else {
                    return null;
                }
            },
            lv2text() {
                if (this.activeLv1 && this.activeLv1.lv1id === 0) {
                    return "常用：";
                } else {
                    return "子类：";
                }
            },
            lv3s() {
                // console.log( (this.activeLv1 && this.activeLv1.tags) || (this.activeLv2 && this.activeLv2.tags))
                return this.activeLv2 && this.activeLv2.lv3;
            },
            filterParams() {
                let filter = {
                    suggest: false, //我的推荐
                    follow: false, //我关注的
                    offset: 0,
                    count: 30,
                    order: "TIME", // TIME | PV | LIKE
                    sort: "DESC", // DESC | ASC
                    classId: 0,
                    tag: [],
                };
                //分类
                if (this.activeLv3 && this.activeLv3.lv3id) {
                    filter.classId = this.activeLv3.lv3id;
                } else if (this.activeLv2 && this.activeLv2.lv2id) {
                    filter.classId = this.activeLv2.lv2id;
                } else if (this.activeLv1 && this.activeLv1.lv1id) {
                    filter.classId = this.activeLv1.lv1id;
                } else {
                    filter.classId = 0;
                }
                // if(this.activeTag && this.activeTag.id){
                //     filter.tagId = this.activeTag.id;
                // }
                //价格
                filter.price = Number(this.price);
                //栏目
                switch (this.activeLabel) {
                    case "suggest": {
                        filter.suggest = true;

                        break;
                    }
                    case "follow": {
                        filter.follow = true;
                        break;
                    }
                    case "race": {
                        filter.tag = ["我要参赛"];
                        break;
                    }
                    default: {
                        filter.order = this.activeLabel;
                        break;
                    }
                }
                return filter;
            },
            expandLeftList() {
                let list = [
                    {
                        id: 0,
                        label: "常规",
                    },
                ];
                let mergeTag = [1000, 1001, 1002]; // 流程图，思维导图，组织结构图
                for (let i = 1; i < this.editorTags.length; i++) {
                    if (mergeTag.includes(this.editorTags[i].lv1id)) {
                        continue;
                    } else {
                        let obj = {
                            id: i - 3,
                            lv1id: this.editorTags[i].lv1id,
                            label: this.editorTags[i].lv1name,
                        };
                        list.push(obj);
                    }
                }
                return list;
            },
            expandContentList() {
                let list = [];
                if (this.activeMenuID == 0) {
                    let mergeTag = [1000, 1001, 1002]; // 流程图，思维导图，组织结构图
                    for (let i = 1; i < this.editorTags.length; i++) {
                        if (mergeTag.includes(this.editorTags[i].lv1id)) {
                            let obj = {
                                id: i,
                                label: this.editorTags[i].lv1name,
                                lv1: this.editorTags[i],
                                child: [],
                            };
                            let lv2 = this.editorTags[i].lv2;
                            for (let j = 0; j < lv2.length; j++) {
                                let temp = {
                                    id: j,
                                    lv2id: lv2[j].lv2id,
                                    libs: lv2[j].libs,
                                    label: lv2[j].lv2name,
                                };
                                obj.child.push(temp);
                            }
                            list.push(obj);
                        } else {
                            break;
                        }
                    }
                    return list;
                } else {
                    let menuID = -1;
                    for (let i = 0; i < this.expandLeftList.length; i++) {
                        if (this.activeMenuID == this.expandLeftList[i].id) {
                            menuID = this.expandLeftList[i].lv1id;
                            break;
                        }
                    }
                    for (let i = 1; i < this.editorTags.length; i++) {
                        if (this.editorTags[i].lv1id == menuID) {
                            let lv2 = this.editorTags[i].lv2;
                            for (let j = 0; j < lv2.length; j++) {
                                let obj = {
                                    id: j,
                                    lv1: this.editorTags[i],
                                    lv2: lv2[j],
                                    label: lv2[j].lv2name,
                                    child: [],
                                };
                                let lv3 = lv2[j].lv3;
                                for (let k = 0; k < lv3.length; k++) {
                                    let temp = {
                                        id: k,
                                        lv3id: lv3[k].lv3id,
                                        libs: lv3[k].libs,
                                        label: lv3[k].lv3name,
                                    };
                                    obj.child.push(temp);
                                }
                                list.push(obj);
                            }
                            break;
                        }
                    }
                }
                return list;
            },
            albumPageStatus() {
                return this.$store.state.tplCenter.albumPageStatus;
            },
            userInfo() {
                return this.$store.state.userInfo;
            },
            activeLabel: {
                get: function () {
                    return this.$store.state.workFilter.order;
                },
                set: function (v) {
                    this.$store.commit("updateWorkFilter", { order: v });
                },
            },
            baseOrder() {
                return this.$store.state.baseOrder;
            },
            notInitTemplates() {
                return this.$store.state.tplCenter.notInitTemplates;
            },
            pcLang() {
                return this.$store.state.pcLang;
            },
            getFollowDone() {
                return this.$store.state.tplCenter.getFollowDone;
            },
        },
        watch: {
            price() {
                this.$emit("on-filter", this.filterParams);
            },
            // editorTags(v){
            //     if(v){
            //         this.$nextTick(()=>{
            //             this.resizeEvent();
            //             this.setActiveLv1(this.editorTags[0], true);
            //             this.$store.commit('setState', {
            //                 type: 'trackClass',
            //                 data: this.editorTags[0]['lv1name']
            //             })
            //         })
            //     }
            // }
            lang() {
                if (!this.internal) {
                    let lang = this.isPC ? this.pcLang : this.lang;
                    this.$store.dispatch("getTagClass", { lang });
                } else {
                    this.$edApi.getTagClass({ lang: this.lang }).then((data) => {
                        this.$store.commit("toTplCenter", {
                            name: "editorTags",
                            data,
                        });
                    });
                }
            },
        },
        mounted() {
            this.initTagClass();
        },
        created() {
            if (this.isPlugin) {
                this.price = "5";
            }
            window.addEventListener("resize", this.resizeEvent);
            this.$bus.$on("initWorkClass", () => {
                this.setActiveLv1(this.editorTags[0], true);
            });
            this.$bus.$on("setFilterPrice", (data) => {
                this.price = data;
            });
            this.$bus.$on("selectWorkClass", (data) => {
                let { refreshTemplate, lv1 } = data;
                this.$store.commit("toTplCenter", {
                    name: "activeAlbumID",
                    data: -1,
                });
                this.$store.commit("toTplCenter", {
                    name: "albumPageStatus",
                    data: "default",
                });
                this.setActiveLv1(lv1, true);
                if (refreshTemplate) {
                    this.$emit("on-filter", {
                        album: null,
                        page: 1,
                        offset: 0,
                        classId: lv1.lv1id,
                    });
                }
            });
            if (this.isPC) {
                let setLocatTagStr = (data) => {
                    let pcInfo =
                        Object.prototype.toString.call(data) == "[object Object]"
                            ? data
                            : Object.prototype.toString.call(data) == "[object String]"
                              ? JSON.parse(data)
                              : null;
                    if (!pcInfo) return;
                    let str = this.searchNameU(pcInfo["NameU"]) || pcInfo["Name"];
                    this.$store.commit("setState", {
                        type: "locatTagStr",
                        data: str,
                    });
                };
                let setKey = (data) => {
                    if (this.mountedDone) {
                        setLocatTagStr(data);
                        this.checkTag();
                    } else {
                        this.getTagCallback.push([setLocatTagStr, data]);
                    }
                };
                this.$bus.$on("setClassifyKey", setKey);
                this.$once("hook:beforeDestroy", () => {
                    this.$bus.$off("setClassifyKey", setKey);
                });
            }
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resizeEvent);
            this.$bus.$off("initWorkClass");
            this.$bus.$off("selectWorkClass");
            this.$bus.$off("setFilterPrice");
        },
        methods: {
            initTagClass() {
                // 重置workclass选中项
                this.$store.commit("setState", { type: "activeLv2", data: null });
                this.$store.commit("setState", { type: "activeLv3", data: null });
                if (!this.internal) {
                    let lang = this.isPC ? this.pcLang : this.lang;
                    this.$store.dispatch("getTagClass", { lang }).then((e) => {
                        if (this.getTagCallback.length > 0) {
                            let item = this.getTagCallback.pop();
                            item[0](item[1]);
                        }
                        console.log(123456, this.notInitTemplates);
                        !this.notInitTemplates && this.checkTag();
                        this.mountedDone = true;
                        this.$store.commit("toTplCenter", {
                            name: "notInitTemplates",
                            data: false,
                        });
                    });
                } else {
                    this.$edApi.getTagClass({ lang: "zh" }).then((data) => {
                        this.$store.commit("toTplCenter", {
                            name: "editorTags",
                            data,
                        });
                        if (this.getTagCallback.length > 0) {
                            let item = this.getTagCallback.pop();
                            item[0](item[1]);
                        }
                        console.log(123456, this.notInitTemplates);
                        !this.notInitTemplates && this.checkTag();
                        this.mountedDone = true;
                        this.$store.commit("toTplCenter", {
                            name: "notInitTemplates",
                            data: false,
                        });
                    });
                }
            },
            checkTag() {
                this.$bus.$emit("clearSearch");
                let notFount = false;
                this.$nextTick(() => {
                    this.resizeEvent();
                    if (this.$store.state.locatTagStr) {
                        let str = this.$store.state.locatTagStr;
                        let obj = null;
                        this.$store.commit("setState", {
                            type: "locatTagStr",
                            data: null,
                        });
                        if (this.$store.state.forceSearch) {
                            this.$store.commit("setState", {
                                type: "forceSearch",
                                data: false,
                            });
                        } else {
                            obj = this.searchTag(str);
                        }
                        if (obj) {
                            this.$store.commit("setState", { type: "activeLv2", data: null });
                            this.$store.commit("setState", { type: "activeLv3", data: null });
                            if (obj.lv1) {
                                this.activeLv1 = obj.lv1;
                                this.$store.commit("setState", {
                                    type: "workClassName",
                                    data: classTrans[obj.lv1.lv1name],
                                });
                            }
                            if (obj.lv1 && obj.lv2) {
                                this.activeLv2 = obj.lv2;
                                this.$store.commit("setState", {
                                    type: "workClassName",
                                    data: classTrans[obj.lv2.lv2name],
                                });
                            } else if (obj.lv1) {
                                this.activeLv2 = obj.lv1.lv2[0];
                                this.$store.commit("setState", {
                                    type: "workClassName",
                                    data: classTrans[this.activeLv2.lv2name],
                                });
                            }
                            if (obj.lv1 && obj.lv2 && obj.lv3) {
                                this.activeLv3 = obj.lv3;
                                this.$store.commit("setState", {
                                    type: "workClassName",
                                    data: classTrans[obj.lv3.lv3name],
                                });
                            }
                            this.filterParams.price = 1; // 设置价格过滤为全部
                            this.price = "1";
                        } else {
                            this.setActiveLv1(this.editorTags[0], true);
                            this.$bus.$emit("setSearchKey", str, "notInit");
                            notFount = true;
                            this.$store.commit("setState", {
                                type: "trackClass",
                                data: this.editorTags[0]["lv1name"],
                            });
                        }
                    } else {
                        this.setActiveLv1(this.editorTags[0], true);
                        this.$store.commit("setState", {
                            type: "trackClass",
                            data: this.editorTags[0]["lv1name"],
                        });
                    }
                    !notFount && this.$emit("on-filter", this.filterParams);
                });
            },
            searchTag(str) {
                if (/^\d{1,}$/.test(str)) {
                    return this.searchTagID(str - 0);
                }
                let list = this.editorTags;
                let obj = {
                    lv1: null,
                    lv2: null,
                    lv3: null,
                };
                for (let lv1 of list) {
                    obj.lv1 = lv1;
                    obj.lv2 = null;
                    obj.lv3 = null;
                    if (lv1.lv1name == str) {
                        return obj;
                    }
                    let lv2List = lv1.lv2;
                    for (let lv2 of lv2List) {
                        obj.lv2 = lv2;
                        obj.lv3 = null;
                        if (lv2.lv2name == str) {
                            return obj;
                        }
                        if (lv2.lv3) {
                            let lv3List = lv2.lv3;
                            for (let lv3 of lv3List) {
                                if (lv3.lv3name == str) {
                                    obj.lv3 = lv3;
                                    return obj;
                                }
                            }
                        }
                    }
                }
                return null;
            },
            searchTagID(id) {
                let list = this.editorTags;
                let obj = {
                    lv1: null,
                    lv2: null,
                    lv3: null,
                };
                for (let lv1 of list) {
                    obj.lv1 = lv1;
                    obj.lv2 = null;
                    obj.lv3 = null;
                    if (lv1.lv1id == id) {
                        return obj;
                    }
                    let lv2List = lv1.lv2;
                    for (let lv2 of lv2List) {
                        obj.lv2 = lv2;
                        obj.lv3 = null;
                        if (lv2.lv2id == id) {
                            return obj;
                        }
                        if (lv2.lv3) {
                            let lv3List = lv2.lv3;
                            for (let lv3 of lv3List) {
                                if (lv3.lv3id == id) {
                                    obj.lv3 = lv3;
                                    return obj;
                                }
                            }
                        }
                    }
                }
                return null;
            },
            searchNameU(nameU) {
                let obj = {
                    "Block Diagram": "1146",
                    Arrows: "1145",
                    Timelines: "1151",
                    "Circle-Spoke Diagram": "1147",
                    "Circular Diagram": "1148",
                    Lists: "1149",
                    "Venn Diagram": "1150",
                    Presentation: "1156",
                    "Basic Flowchart": "1009",
                    "Data Flow Diagram": "1011",
                    "Cross Functional Flowchart": "1010",
                    BPMN: "1012",
                    "Event Flow Diagram": "1013",
                    "IDEF Diagram": "1014",
                    "SDL Diagram": "1015",
                    "Workflow Diagram": "1016",
                    "Audit Diagram": "1017",
                    mindmap: "1001",
                    "Concept Map": "5012",
                    "Bubble Diagram": "5013",
                    "Organizational Chart": "1002",
                    "Org Structure": "1027",
                    "Family Tree": "5006",
                    Column: "1088",
                    Bar: "1089",
                    Pie: "1090",
                    Doughnut: "1091",
                    Line: "1092",
                    Area: "1093",
                    Scatter: "1094",
                    "Bubble Chart": "1095",
                    Gauges: "1096",
                    "Comparison Chart": "5010",
                    "Spider and Radar": "1097",
                    "Report Form": "1098",
                    Invoice: "1099",
                    "Sales Form": "1100",
                    "Expense Report": "1101",
                    "Inventory List": "1102",
                    "Quote Form": "1103",
                    "Enterprise Architecture": "1159",
                    Agenda: "1152",
                    "Business Process": "1153",
                    "Human Resource": "1154",
                    "Team Cooperation": "1155",
                    "Vision and Mission": "1157",
                    Roadmap: "1158",
                    "Decision Making": "1177",
                    "Fault Tree Analysis": "1178",
                    "Plan-Do-Check-Act": "1179",
                    "Cause and Effect Diagram": "1185",
                    "House of Quality": "1180",
                    "Relation Diagram": "1181",
                    "Seven Basic Tools of Quality": "1182",
                    "TQM Diagram": "1183",
                    "Value Stream Mapping": "1184",
                    "Gantt Charts": "1195",
                    "Kanban Diagrams": "1196",
                    Checklists: "1197",
                    "Project Calendar": "1198",
                    "Relationship Matrix": "1199",
                    "PERT Chart": "1200",
                    "Decision Tree": "1201",
                    "Status Table": "5011",
                    "WBS Diagram": "5009",
                    "Affinity Diagram": "1186",
                    "Matrix Diagram": "1187",
                    "Competitive Analysis": "1188",
                    "Five Forces Analysis": "1189",
                    "Force Field Analysis": "1190",
                    "Performance Prism": "1192",
                    "Value Chain Analysis": "1194",
                    Comparisons: "1104",
                    "Customer Journey Mapping": "1163",
                    "Funnel Charts": "1105",
                    "Marketing Diagrams": "1108",
                    Puzzles: "1160",
                    "Pyramid Diagrams": "1106",
                    Sales: "1107",
                    "Target Diagrams": "1162",
                    "PEST Analysis": "1193",
                    "Business Analysis": "1171",
                    "Product Planning": "1172",
                    "Project Progress Analysis": "1173",
                    "Strategy Analysis": "1174",
                    "Team Management": "1175",
                    "Lifelong Learning": "1176",
                    "UML Modeling": "1050",
                    "Booch OOD": "1051",
                    "COM and OLE": "1236",
                    "Data Flow Model Diagram": "1052",
                    "Enterprise Application": "1053",
                    "Jacobson Use Case": "1054",
                    Jackson: "1055",
                    "Program Flowchart": "1056",
                    "Program Structure": "1057",
                    "Nassi-Shneiderman": "1058",
                    Room: "1059",
                    "Shlaer-Mellor OOA": "1060",
                    SSADM: "1061",
                    "Yourdon and Coad": "1062",
                    "Chen ERD": "1063",
                    "Database Model Diagram": "1064",
                    "Express-G": "1065",
                    "Martin ERD": "1066",
                    "ORM Diagram": "1067",
                    "Basic Network Diagram": "1071",
                    "Cisco Network Topology": "1072",
                    "Cisco Product Icons": "1073",
                    "Cisco Safe Icons": "1074",
                    "Detail Network Diagram": "1075",
                    "Logical Network Diagram": "1076",
                    "Rack Diagram": "1077",
                    LDAP: "1078",
                    "Active Directory": "1079",
                    "Network Location Diagram": "1080",
                    "Video and Audio Ports": "1081",
                    AWS: "1068",
                    Azure: "1069",
                    GCP: "1070",
                    "Floor Plan": "1120",
                    "Home Plan": "1121",
                    "Office Layout": "1122",
                    "Electrical and Telecom Plan": "1123",
                    "Seating Plan": "1124",
                    "Security and Access Plan": "1125",
                    "Garden Design": "1126",
                    "Fire and Emergency Plan": "1127",
                    "Reflected Ceiling Plan": "1128",
                    "Plumbing and Piping Plan": "1129",
                    Elevations: "1130",
                    Wardrobe: "1131",
                    "Basic Electrical": "1109",
                    "Circuits and Logic": "1110",
                    "Industrial Control Systems": "1111",
                    Systems: "1112",
                    "Process P&ID": "1115",
                    "Utility-Generation P&ID": "1116",
                    "Environmental P&ID": "1117",
                    "Auxillary System P&ID": "1118",
                    "Distribution P&ID": "1119",
                    "Process Flow Diagram": "1113",
                    "Piping and Instrumentation Diagram": "1114",
                    "Directional Map 3D": "1132",
                    "Geo Map": "1135",
                    "Directional Map": "1133",
                    "Subway Map": "1134",
                    "Annual Reports": "1202",
                    Banner: "1203",
                    Brochure: "1204",
                    Certificate: "1205",
                    Cover: "1206",
                    Flyer: "1207",
                    Label: "1208",
                    Magazines: "1209",
                    Newsletter: "1210",
                    "Picture Collage": "1211",
                    Poster: "1212",
                    Architecture: "1213",
                    Business: "1214",
                    Education: "1215",
                    Environment: "1216",
                    Food: "1217",
                    Medical: "1218",
                    Music: "1219",
                    News: "1221",
                    Technology: "1220",
                    Tourism: "1222",
                    Transportation: "1223",
                    "Business Card": "1224",
                    "Thank You Card": "1225",
                    "Invitation Card": "1226",
                    Postcard: "1227",
                    "Birthday Card": "1228",
                    Christmas: "1229",
                    Halloween: "1230",
                    Carnival: "1231",
                    "Childrens Day": "1232",
                    Easter: "1233",
                    "New Year": "1234",
                    "Valentines Day": "1235",
                    "Website Wireframe": "1082",
                    "Windows UI": "1083",
                    "iPhone UI": "1084",
                    "Android UI": "1085",
                    "iPad UI": "1237",
                    "Conceptual Web Site": "1238",
                    "Website Map": "1239",
                    Mechanics: "1137",
                    Optics: "1138",
                    "Chemistry Equation": "1141",
                    "Laboratory Equipment": "1142",
                    "Molecular Model": "1144",
                    Mathematics: "1136",
                    Genogram: "5007",
                    "Human Organs": "1143",
                    Biology: "1139",
                    Astronomy: "1140",
                    "Compare and Contract": "1242",
                    "Grid and Matrix": "1242",
                    "Main Idea and Detail": "1242",
                    "Sequence Chart": "1242",
                    "Spider Chart": "1242",
                    Storyboard: "1242",
                    "T-Chart": "1242",
                };
                let classifyID = obj[nameU];
                if (classifyID) {
                    return classifyID;
                }
                return null;
            },
            closeMind() {
                this.showMindmaster = false;
            },
            seeNow() {
                if (this.isPC) {
                    window.$qt.jsCallOpenUrl(this.internal ? "https://mm.edrawsoft.cn/create" : "https://www.mindmaster.io/online/create");
                } else {
                    window.open(this.internal ? "https://mm.edrawsoft.cn/create" : "https://www.mindmaster.io/online/create");
                }
            },
            lv2Class(lv2) {
                if (this.activeLv2 && lv2.lv2id === this.activeLv2.lv2id) {
                    // if(lv2.lv3){
                    //     return { "color__active": true}
                    // }else{
                    //     return  {'color__active': true}
                    // }
                    return { color__active: true };
                }
            },
            // setActiveClass(data) {
            //     if (this.activeClass.lv1id == data.lv1id && this.activeClass.lv2id == data.lv2id) return;
            //     this.activeClass = data;
            //     this.activeLabel = "PV";
            //     this.$emit("on-filter", this.filterParams);
            // },
            toggleFold(type) {
                this["lv" + type + "line"] = parseInt(3 - this["lv" + type + "line"]);
            },
            resizeEvent() {
                if (this.$refs.lv1Con) {
                    if (this.$refs.lv1Con.firstElementChild?.offsetTop !== this.$refs.lv1Con.lastElementChild?.offsetTop) {
                        this.lv1line = this.lv1line || 1;
                    } else {
                        this.lv1line = 0;
                    }
                }
                if (this.$refs.lv2Con) {
                    if (this.$refs.lv2Con.firstElementChild?.offsetTop !== this.$refs.lv2Con.lastElementChild?.offsetTop) {
                        this.lv2line = this.lv2line || 1;
                    } else {
                        this.lv2line = 0;
                    }
                }
                if (this.$refs.lv3Con) {
                    if (this.$refs.lv3Con.firstElementChild?.offsetTop !== this.$refs.lv3Con.lastElementChild?.offsetTop) {
                        this.lv3line = this.lv3line || 1;
                    } else {
                        this.lv3line = 0;
                    }
                }
            },
            ImgUrl(lv, type) {
                if (this["activeLv" + type] && this["activeLv" + type]["lv" + type + "id"] === lv["lv" + type + "id"]) {
                    return window["GLOBAL"].PUBLIC_OSS_HOST + encodeURIComponent(lv.icon.replace(/(.[^.]*)$/, "-active" + "$1"));
                } else {
                    return window["GLOBAL"].PUBLIC_OSS_HOST + encodeURIComponent(lv.icon);
                }
            },
            setActiveLv1(lv1, inited) {
                this.sensors.track("categoryPage", {
                    Catalogues: "Templates",
                    platform: this.isPC ? "desktop" : "online",
                });
                // if(lv1 && this.activeLv1 &&this.activeLv1.lv1id === lv1.lv1id) return;
                inited = inited || false;
                !inited && this.$bus.$emit("clearSearch");
                this.activeLv3 = null;
                this.activeLv2 = null;
                this.activeLv1 = lv1;
                this.activeLabel = this.baseOrder;
                if (this.isPC && !inited) {
                    // window.$qt.jsCallUploadData && window.$qt.jsCallUploadData(JSON.stringify({
                    //     type: "S006_Use_Template_8",
                    //     action: "SL038_Category_1",
                    //     label: JSON.stringify({name:classTrans[lv1.lv1name]})
                    // }));
                    this.$pcTrack(
                        JSON.stringify({
                            type: "Templates",
                            action: "clickCommunityTemplateCategory",
                            event: "experience",
                            label: JSON.stringify({
                                template_category_name: classTrans[lv1.lv1name],
                            }),
                        })
                    );
                    this.$store.commit("setState", {
                        type: "trackClass",
                        data: classTrans[lv1.lv1name],
                    });
                }
                this.$store.commit("setState", {
                    type: "workClassName",
                    data: classTrans[lv1.lv1name],
                });
                localStorage.setItem("tagTrackArg", lv1.lv1id);
                if (lv1.libs) {
                    this.$store.commit("setLibID", lv1.libs);
                } else {
                    this.$store.commit("setLibID", []);
                }
                this.$store.commit("setTagID", lv1.lv1id);
                if (lv1 && lv1.lv1id && lv1.lv2) {
                    this.setActiveLv2(lv1.lv2[0], inited);
                } else {
                    if (!inited) {
                        this.activeLv2 = null;
                        this.$emit("on-filter", this.filterParams);
                        this.sensors.track("clickCommunityTemplateCategory", {
                            Catalogues: "Templates",
                            template_category_name: classTrans[lv1.lv1name],
                            platform: this.isPC ? "desktop" : "online",
                        });
                    }
                }
                this.$nextTick(() => {
                    this.resizeEvent();
                });
            },
            setActiveLv2(lv2, inited) {
                this.sensors.track("categoryPage", {
                    Catalogues: "Templates",
                    platform: this.isPC ? "desktop" : "online",
                });
                if (lv2.lv2id == 1019) {
                    this.showMindmaster = true;
                    this.$nextTick(() => {
                        this.$refs.mindTip.focus();
                    });
                    return;
                }
                if (this.activeLv2 && this.activeLv2.lv2id === lv2.lv2id) return;
                inited = inited || false;
                !inited && this.$bus.$emit("clearSearch");
                this.activeLv3 = null;
                this.activeLv2 = lv2;
                this.activeLabel = this.baseOrder;
                if (this.isPC && !inited) {
                    let action = lv2.lv3 ? "SL038_Category_1" : "SL039_Category_2";
                    // window.$qt.jsCallUploadData && window.$qt.jsCallUploadData(JSON.stringify({
                    //     type: "S006_Use_Template_8",
                    //     action,
                    //     label: JSON.stringify({name:classTrans[lv2.lv2name]})
                    // }));
                    this.$pcTrack(
                        JSON.stringify({
                            type: "Templates",
                            action: "clickCommunityTemplateCategory",
                            event: "experience",
                            label: JSON.stringify({
                                template_category_name: classTrans[lv2.lv2name],
                            }),
                        })
                    );
                    this.$store.commit("setState", {
                        type: "trackClass",
                        data: classTrans[lv2.lv2name],
                    });
                }
                this.$store.commit("setState", {
                    type: "workClassName",
                    data: classTrans[lv2.lv2name],
                });
                localStorage.setItem("tagTrackArg", lv2.lv2id);
                if (lv2.libs) {
                    this.$store.commit("setLibID", lv2.libs);
                } else {
                    this.$store.commit("setLibID", []);
                }
                if (!inited) {
                    this.$emit("on-filter", this.filterParams);
                    this.$track("Expandcategory", "clickcategory", `type: ${classTrans[lv2.lv2name]}`);
                    this.sensors.track("clickCommunityTemplateCategory", {
                        Catalogues: "Templates",
                        template_category_name: classTrans[lv2.lv2name],
                        platform: this.isPC ? "desktop" : "online",
                    });
                }
                this.$nextTick(() => {
                    this.resizeEvent();
                });
            },
            setActiveLv3(lv3) {
                this.sensors.track("categoryPage", {
                    Catalogues: "Templates",
                    platform: this.isPC ? "desktop" : "online",
                });
                if (this.activeLv3 && this.activeLv3.lv3id === lv3.lv3id) return;
                this.$bus.$emit("clearSearch");
                this.activeLv3 = lv3;
                this.activeLabel = this.baseOrder;
                if (this.isPC) {
                    // window.$qt.jsCallUploadData && window.$qt.jsCallUploadData(JSON.stringify({
                    //     type: "S006_Use_Template_8",
                    //     action: "SL039_Category_2",
                    //     label: JSON.stringify({name:classTrans[lv3.lv3name]})
                    // }));
                    this.$pcTrack(
                        JSON.stringify({
                            type: "Templates",
                            action: "clickCommunityTemplateCategory",
                            event: "experience",
                            label: JSON.stringify({
                                template_category_name: classTrans[lv3.lv3name],
                            }),
                        })
                    );
                    this.$store.commit("setState", {
                        type: "trackClass",
                        data: classTrans[lv3.lv3name],
                    });
                } else {
                    this.$track("Expandcategory", "clickcategory", `type: ${classTrans[lv3.lv3name]}`);
                    this.sensors.track("clickCommunityTemplateCategory", {
                        Catalogues: "Templates",
                        template_category_name: classTrans[lv3.lv3name],
                        platform: this.isPC ? "desktop" : "online",
                    });
                }
                this.$store.commit("setState", {
                    type: "workClassName",
                    data: classTrans[lv3.lv3name],
                });
                localStorage.setItem("tagTrackArg", lv3.lv3id);
                if (lv3.libs) {
                    this.$store.commit("setLibID", lv3.libs);
                } else {
                    this.$store.commit("setLibID", []);
                }
                this.$emit("on-filter", this.filterParams);
                this.$nextTick(() => {
                    this.resizeEvent();
                });
            },
            setActiveLabel(label) {
                if (label == "FOLLOW" && this.userInfo && this.userInfo.user_id && !this.getFollowDone) return;
                if (this.showSpin) return; // 未加载完不能切换label
                if (this.activeLabel == label) return;
                this.activeLabel = label;
                // if (label == "suggest" || label == "follow") {
                //     this.activeClass = {};
                // }
                // this.price = "1";
                this.$emit("on-filter", {
                    order: this.activeLabel,
                    page: 1,
                    offset: 0,
                });
            },

            showExpandBox() {
                this.showExpand = true;
                this.$track("Expandcategory", "clickbutton", "");
            },
            closeExpand() {
                this.showExpand = false;
            },
            selectExpandLeftMenu(id) {
                let dom = this.$refs.expandLeftbar;
                dom.style.setProperty("--top", id * 52);
                this.activeMenuID = id;
                this.activeSearchID = -1;
            },
            toExpandTag(parent, target) {
                this.closeExpand();
                if (this.activeMenuID == 0) {
                    // 常用
                    this.activeLv1 = parent.lv1;
                    this.setActiveLv2(target);
                } else {
                    this.activeLv1 = parent.lv1;
                    this.activeLv2 = parent.lv2;
                    this.setActiveLv3(target);
                }
            },
            searchExpand() {
                for (let i = 1; i < this.editorTags.length; i++) {
                    if (i <= 3) {
                        // 流程图，思维导图，组织结构图
                        let arr = this.editorTags[i].lv2;
                        for (let j = 0; j < arr.length; j++) {
                            if (arr[j].lv2name.includes(this.searchStr)) {
                                this.selectExpandLeftMenu(0);
                                this.activeSearchID = arr[j].lv2id;
                                console.log("search success");
                                return;
                            }
                        }
                    } else {
                        let arr = this.editorTags[i].lv2;
                        for (let j = 0; j < arr.length; j++) {
                            let list = arr[j].lv3;
                            for (let k = 0; k < list.length; k++) {
                                if (list[k].lv3name.includes(this.searchStr)) {
                                    this.selectExpandLeftMenu(i - 3);
                                    this.activeSearchID = list[k].lv3id;
                                    console.log("search success");
                                    return;
                                }
                            }
                        }
                    }
                }
                this.$edMessage.warning("没有找到相关标签");
            },
        },
    };
</script>
